module.exports = __webpack_public_path__ + "img/SUR.6b6963b5.svg";